export default function Placeholder({ title, description, testid }) {
  return (
    <div data-testid={testid}>
      <div className="se-label">Module</div>
      <h1 className="font-heading mt-1" style={{ fontSize: 28 }}>{title}</h1>
      <p className="text-sm mt-1 mb-8" style={{ color: "#8C9E8A" }}>{description}</p>
      <div className="se-card text-center" style={{ padding: 48 }}>
        <p style={{ color: "#8C9E8A" }}>
          This module is part of the next phase. The data model and tenant scoping are already in place — UI is coming next.
        </p>
      </div>
    </div>
  );
}
